import React from "react";
import { LEGO_BRICK_TYPES } from "../../utils/brickOptimizer";
import { getColorHex } from "../../constants/bomPricing";

interface BrickTypeShapeProps {
  brickType: (typeof LEGO_BRICK_TYPES)[0];
  colorName: string;
}

const BrickTypeShape: React.FC<BrickTypeShapeProps> = ({ brickType, colorName }) => {
  const studs = brickType.width * brickType.height;
  const cellSize = 8;

  return (
    <div className="brick-type-visual">
      <div
        className="brick-shape-chip"
        style={{
          width: `${Math.max(16, brickType.width * cellSize)}px`,
          height: `${Math.max(16, brickType.height * cellSize)}px`,
          gridTemplateColumns: `repeat(${brickType.width}, 1fr)`,
          gridTemplateRows: `repeat(${brickType.height}, 1fr)`,
          backgroundColor: getColorHex(colorName),
        }}
      >
        {Array.from({ length: studs }, (_, i) => (
          <span key={i} className="brick-shape-stud" />
        ))}
      </div>
      <span className="brick-shape-label">{brickType.name}</span>
    </div>
  );
};

export default BrickTypeShape;
